import React from 'react';

/**
 * 개인정보 처리방침 페이지
 * 회사명: (주)오딘소프트
 */
const PrivacyPolicy = () => {
  return (
    <div className="container mx-auto px-6 py-6 ml-6">
      <h1 className="text-2xl font-bold mb-4">개인정보 처리방침</h1>
      <p className="mb-6">(주)오딘소프트는 고객님들의 소중한 개인정보 보호를 위해 아래와 같은 방침을 수행하고 있습니다.</p>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">1. 개인정보의 처리 목적</h2>
        <p className="mb-2">(주)오딘소프트(&#39;lion.odinsoft.co.kr&#39;이하 &#39;로또라이온&#39;)은 다음의 목적을 위하여 개인정보를 처리하고 있으며, 다음의 목적 이외의 용도로는 이용하지 않습니다.</p>
        <ul className="list-disc list-inside">
          <li>고객 가입의사 확인, 본인 식별·인증</li>
          <li>회원자격 유지·관리</li>
        </ul>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">2. 개인정보의 처리 및 보유 기간</h2>
        <p className="mb-2">로또라이온는 정보주체로부터 동의 받은 보유 및 이용기간 또는 법령에 따른 보유 기간 내에서 개인정보를 처리·보유합니다.</p>
        <p className="mb-2">구체적인 개인정보 처리 및 보유 기간은 다음과 같습니다:</p>
        <ul className="list-disc list-inside">
          <li>회원 가입 및 관리: 탈퇴 시 즉시 삭제</li>
        </ul>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">3. 정보주체의 권리·의무 및 그 행사방법</h2>
        <p className="mb-2">이용자는 개인정보주체로서 다음과 같은 권리를 행사할 수 있습니다:</p>
        <ul className="list-decimal list-inside">
          <li>개인정보 열람 요구</li>
          <li>오류 정정 요구</li>
          <li>삭제 요구</li>
          <li>처리 정지 요구</li>
        </ul>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">4. 처리하는 개인정보의 항목</h2>
        <p className="mb-2">로또라이온은 다음의 개인정보 항목을 처리하고 있습니다:</p>
        <h3 className="font-semibold">■ 회원 가입 시(회원)</h3>
        <ul className="list-disc list-inside mb-4">
          <li>필수항목: 이름, 이메일, 전화번호</li>
          <li>선택항목: 생년월일</li>
        </ul>
        <h3 className="font-semibold">■ 고객 문의 시(비회원)</h3>
        <ul className="list-disc list-inside">
          <li>필수항목: 문의종류, 이름, 휴대폰번호, 이메일, 문의사항</li>
        </ul>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">5. 개인정보의 파기</h2>
        <p className="mb-2">로또라이온는 개인정보 처리 목적 달성 후 지체 없이 해당 정보를 파기합니다.</p>
        <ul className="list-disc list-inside">
          <li>파기절차: DB에서 별도 보관 후 내부 방침에 따라 파기</li>
          <li>파기기한: 보유 기간 종료 후 5일 이내</li>
        </ul>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">6. 개인정보 자동 수집 장치의 설치·운영 및 거부</h2>
        <p className="mb-2">로또라이온는 쿠키를 사용합니다. 쿠키 설정 거부 시 맞춤형 서비스 이용에 어려움이 발생할 수 있습니다.</p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">7. 개인정보 보호책임자</h2>
        <p className="mb-2">로또라이온는 아래와 같이 개인정보 보호책임자를 지정하고 있습니다:</p>
        <ul className="list-disc list-inside">
          <li>성명: 이성안</li>
          <li>직책: 대표이사</li>
          <li>연락처: help@odinsoft.co.kr</li>
        </ul>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">8. 개인정보 처리방침 변경</h2>
        <p>본 방침은 시행일로부터 적용되며, 변경 시 7일 전부터 공지사항을 통해 안내합니다.</p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">9. 개인정보의 안전성 확보 조치</h2>
        <ul className="list-disc list-inside">
          <li>개인정보 취급 직원 최소화 및 교육</li>
          <li>해킹 대비 보안프로그램 설치 및 점검</li>
          <li>개인정보 암호화</li>
          <li>접속기록 보관 및 위변조 방지</li>
          <li>접근 제한 및 침입차단 시스템 운영</li>
        </ul>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-2">10. 권익침해 구제방법</h2>
        <p>로또라이온 자체 처리 결과에 만족하지 못하실 경우 아래 기관에 문의 가능합니다:</p>
        <ul className="list-disc list-inside">
          <li>개인정보침해신고센터: privacy.kisa.or.kr</li>
          <li>개인정보 분쟁조정위원회: www.kopico.go.kr</li>
        </ul>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
